import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=72d88027&scoped=true&"
import script from "./Demand.vue?vue&type=script&lang=js&"
export * from "./Demand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d88027",
  null
  
)

export default component.exports